import ReactMarkdown from 'react-markdown';
import type {ReactElement} from 'react';
import rehypeSanitize from 'rehype-sanitize';

function MarkdownRenderer({content}: {content: string}): ReactElement {
  return (
    <ReactMarkdown rehypePlugins={[rehypeSanitize]}>
      {content}
    </ReactMarkdown>
  );
}

export default MarkdownRenderer;
